<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }">
      <order-table :params="queryParams" :list="list" />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SupplierOrderList',
  components: {
    Pagination: () => import('@/components/Pagination'),
    OrderTable: () => import('@/components/Order/order-table')
  },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      queryParams: {
        keyword: '', // 关键词（用户昵称、手机号、分享码）
        dateRange: '', // 下单日期范围
        orderNumber: '',
        orderStatus: '0',
        orderType: '', // 特权礼包
        payNumber: '',
        logisticsNumber: '',
        dateStart: '',
        dateEnd: '',
        supplierId: '',
        supplierName: '',
        consigneeInfo: '',
        page: 1,
        limit: 10
      }
    }
  },
  methods: {
    fetchData() {}
  }
}
</script>

<style lang="scss" scoped>

</style>
